import { Injectable } from '@angular/core';

declare let gtag: Function; // Declare gtag globally

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor() {}

  // Standard event tracking
  sendEvent(eventName: string, eventData: any) {
      gtag('event', eventName, eventData);
  }

  // Key event tracking
  sendKeyEvent(eventName: string, eventData: any) {
      const keyEventData = {
        ...eventData,
        isKeyEvent: true,
        timestamp: new Date().toISOString(),
      };

      gtag('event', eventName, keyEventData);
  }
}
